import React from 'react'

// The Kodi brand mark: a four-point sparkle with a filled bottom-left circle and an
// outlined top-right plus. Static — no animation.
export const KodiMarkIcon = ({ size = 16, color = 'currentColor', className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
      fill={color}
    />
    <path d="M20 3v4M22 5h-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="4.6" cy="18.4" r="1.5" fill={color} />
  </svg>
)

export const KodiOutlineIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.34976 10.1013C6.28957 9.86798 6.16796 9.65507 5.99759 9.48469C5.82722 9.31432 5.6143 9.19271 5.38099 9.13253L1.24504 8.06601C1.17448 8.04598 1.11237 8.00348 1.06815 7.94496C1.02393 7.88644 1 7.81509 1 7.74174C1 7.66839 1.02393 7.59704 1.06815 7.53852C1.11237 7.48 1.17448 7.4375 1.24504 7.41747L5.38099 6.35028C5.61422 6.29015 5.82708 6.16864 5.99744 5.9984C6.16781 5.82815 6.28947 5.61537 6.34976 5.38219L7.41627 1.24624C7.4361 1.17539 7.47856 1.11298 7.53717 1.06852C7.59577 1.02407 7.66732 1 7.74088 1C7.81444 1 7.88599 1.02407 7.9446 1.06852C8.00321 1.11298 8.04566 1.17539 8.06549 1.24624L9.13133 5.38219C9.19152 5.6155 9.31313 5.82841 9.4835 5.99879C9.65387 6.16916 9.86679 6.29077 10.1001 6.35095L14.2361 7.4168C14.3072 7.43641 14.3699 7.47883 14.4146 7.53752C14.4593 7.59622 14.4835 7.66796 14.4835 7.74174C14.4835 7.81552 14.4593 7.88726 14.4146 7.94596C14.3699 8.00466 14.3072 8.04707 14.2361 8.06668L10.1001 9.13253C9.86679 9.19271 9.65387 9.31432 9.4835 9.48469C9.31313 9.65507 9.19152 9.86798 9.13133 10.1013L8.06481 14.2372C8.04499 14.3081 8.00253 14.3705 7.94392 14.415C7.88532 14.4594 7.81377 14.4835 7.74021 14.4835C7.66664 14.4835 7.5951 14.4594 7.53649 14.415C7.47788 14.3705 7.43543 14.3081 7.4156 14.2372L6.34976 10.1013Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="M13.1338 1.17398C13.4097 1.17415 13.6336 1.3981 13.6338 1.67398V2.52261H14.4814C14.7575 2.52261 14.9813 2.74663 14.9814 3.02261C14.9813 3.29861 14.7575 3.52261 14.4814 3.52261H13.6338V4.37027C13.6338 4.64631 13.4098 4.8701 13.1338 4.87027C12.8578 4.87013 12.6338 4.64632 12.6338 4.37027V3.52261H11.7852C11.5092 3.52247 11.2853 3.29852 11.2852 3.02261C11.2853 2.74672 11.5092 2.52276 11.7852 2.52261H12.6338V1.67398C12.634 1.39808 12.8579 1.17412 13.1338 1.17398Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="M2.75171 13.0676C3.3102 13.0676 3.76295 12.6148 3.76295 12.0563C3.76295 11.4979 3.3102 11.0451 2.75171 11.0451C2.19322 11.0451 1.74048 11.4979 1.74048 12.0563C1.74048 12.6148 2.19322 13.0676 2.75171 13.0676Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
)
